module.exports = "<div class=\"alert alert-warning\">  \nAttenzione! Il link per la conferma è scaduto\n<div>\n<b><a href=\"/\" class=\"btn btn-xs \">Torna alla home page</a></b>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/account/account-confirmation-expired.component.html
// module id = ../../../../../src/app/components/account/account-confirmation-expired.component.html
// module chunks = main